<template>
	<div
		:class="{
			'service-item': true,
			'service-offline-item': item.status == 1,
		}"
	>
		<div class="item-name-group">
			<!-- <div
				:class="{ 'item-icon': true, 'item-icon2': item.status == 1 }"
			></div> -->
			<div
				v-if="item.icon"
				:class="{
					'service-logo': true,
				}"
				:style="{
					'background-image': 'url(\'' + item.icon + '\')',
				}"
			></div>
			<div
				v-else
				:class="{
					'service-logo': true,
					'service-logo-nas': item.dtype == 1,
					'service-logo-router': item.dtype == 2,
					'service-logo-pc': item.dtype == 3 || item.dtype == 999,
				}"
			></div>
			<div class="item-text">
				<div
					class="item-name"
					:title="item.uname ? item.uname : item.name"
					v-if="!isShowNameEdit"
					@click="showNameEdit"
				>
					{{ item.uname ? item.uname : item.name }}
				</div>
				<div class="item-name-edit" v-else>
					<input
						v-model="name"
						id="name"
						@blur="saveNameEdit(item)"
						@keydown.enter="saveNameEdit(item)"
					/>
				</div>
				<div class="item-ip">
					<div class="item-ip-dot"></div>
					{{ $common.ipConvert(item.ip)
					}}{{
						item.status == 1
							? ""
							: item.port
							? " : " + item.port
							: ""
					}}
				</div>
			</div>
		</div>
		<!--离线-->
		<template v-if="item.status == 1">
			<!--dtype：1nas 2路由 3winpc可开机-->
			<template v-if="item.dtype == 3">
				<div class="remote-btn" @click="openClick(item)">开机唤醒</div>
			</template>
			<!--其它类型置灰-->
			<template v-else>
				<div class="remote-btn remote-offline-btn">
					{{ item.btn }}
				</div>
			</template>
		</template>
		<!--在线-->
		<template v-else>
			<template v-if="item.port">
				<div class="remote-btn" @click="controlClick(item)">
					{{ item.btn }}
					<div class="remote-hover-btn">
						<div class="svg-wrap">
							<div class="svg-icon"></div>
						</div>
						<div class="visit-text">访问</div>
					</div>
				</div>
			</template>
		</template>
		<div class="line"></div>
		<div class="master-name">
			<div class="name-icon"></div>
			{{
				item.dev.term.comment
					? item.dev.term.comment
					: item.dev.term.name
					? item.dev.term.name
					: item.dev.peerid
			}}
		</div>
		<div class="delete-btn" v-if="isShowDelete" @click="deleteClick"></div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	data: function () {
		return {
			name: "",
			isShowNameEdit: false,
		};
	},
	props: ["item", "isShowDelete", "index"],
	methods: {
		...mapActions(["sendUserlog"]),
		deleteClick: function () {
			let _that = this;
			this.$emit("deleteClick", _that.item, _that.index);
		},
		showNameEdit: function () {
			this.isShowNameEdit = true;
			setTimeout(function () {
				document.getElementById("name").focus();
			}, 500);
		},
		hideNameEdit: function () {
			this.isShowNameEdit = false;
		},
		saveNameEdit: function (item) {
			this.hideNameEdit();
			item.uname = this.name;
			this.$emit("nameEditClick", item);
		},
		controlClick: function (item) {
			let _that = this;
			this.$emit("controlClick", item);
		},
		openClick: function (item) {
			let _that = this;
			_that.$emit("openClick", item);
		},
	},
	mounted: function () {
		this.name = this.item.uname ? this.item.uname : this.item.name;
	},
};
</script>

<style lang="less" scoped>
.service-item {
	position: relative;
	margin: 6px;
	display: inline-block;
	vertical-align: top;
	width: 292px;
	height: 118px;
	border: 1px solid #e8c29b;
	border-radius: 8px;
	background: linear-gradient(
		152deg,
		rgba(252, 232, 209, 0.3) 21%,
		rgba(243, 209, 169, 0.3) 83%
	);

	.item-name-group {
		padding-top: 24px;

		.service-logo {
			display: inline-block;
			margin-left: 16px;
			margin-right: 8px;
			vertical-align: top;
			width: 42px;
			height: 42px;
			border-radius: 22px;
			background-repeat: no-repeat;
			background-position: center center;
			background-size: 70% 70%;
		}

		.service-logo {
			background-color: #fff6e5;
			border: 1px solid #cea772;
		}
		.service-logo.service-logo-nas {
			background-image: url(../../assets/common/vip-nas-icon.svg);
		}
		.service-logo.service-logo-router {
			background-image: url(../../assets/common/vip-router-icon.svg);
		}
		.service-logo.service-logo-pc {
			background-image: url(../../assets/common/vip-windows-icon.svg);
		}

		.item-icon {
			display: inline-block;
			margin-left: 16px;
			margin-right: 8px;
			vertical-align: top;
			width: 42px;
			height: 42px;
			background-image: url(../../assets/remote/deviceOnVip.png);
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
		.item-icon2 {
			background-image: url(../../assets/remote/deviceOffVip.png);
		}
		.item-text {
			display: inline-block;
			vertical-align: top;
			.item-name {
				width: 126px;
				line-height: 24px;
				font-size: 16px;
				font-weight: 700;
				color: #1a1a1a;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.item-name-edit {
				margin-top: -2px;
				background-color: #ffffff;
				width: 120px;
				height: 28px;
				line-height: 28px;
				border-radius: 15px;
				border: 1px solid #eeeeee;
				box-shadow: 0px 0px 2px 0px #eeeeee;
				box-sizing: border-box;
				input {
					display: inline-block;
					margin-left: 7px;
					background-color: transparent;
					width: 110px;
					height: 28px;
					line-height: 28px;
					font-size: 16px;
					font-weight: 700;
					color: #1b358b;
					vertical-align: top;
				}
			}
			.item-ip {
				margin-top: 4px;
				font-size: 12px;
				line-height: 16px;
				color: #666666;
				.item-ip-dot {
					display: inline-block;
					margin-top: 6px;
					vertical-align: top;
					width: 4px;
					height: 4px;
					background-color: #666666;
					border-radius: 2px;
				}
			}
		}
	}
	.remote-btn {
		position: absolute;
		right: 16px;
		top: 31px;
		width: 72px;
		height: 28px;
		line-height: 28px;
		background-color: #243a5d;
		box-shadow: 0px 2px 4px rgba(10, 43, 115, 0.2);
		border-radius: 24px;
		color: #ffffff;
		font-size: 12px;
		text-align: center;
		cursor: pointer;
		overflow: hidden;
		.remote-hover-btn {
			opacity: 0;
			position: absolute;
			top: 0;
			left: 0;
			width: 72px;
			height: 28px;
			background-color: #fffbf2;
			border-radius: 24px;
			.svg-wrap {
				display: inline-block;
				vertical-align: top;
				.svg-icon {
					margin-top: 5px;
					width: 16px;
					height: 16px;
					background-image: url("../../assets/vip/rocket.svg");
					background-repeat: no-repeat;
					background-size: 100% 100%;
					transition: transform 0.3s ease-in-out;
				}
			}

			.visit-text {
				display: inline-block;
				margin-left: 4px;
				vertical-align: top;
				line-height: 28px;
				transition: all 0.3s ease-in-out;
			}
		}
	}
	.remote-btn:hover {
		.remote-hover-btn {
			opacity: 100%;

			.svg-wrap {
				animation: fly-1 0.6s ease-in-out infinite alternate;

				.svg-icon {
					transform: translateX(1.2em) rotate(45deg) scale(1.1);
				}
			}
			@keyframes fly-1 {
				from {
					transform: translateY(0.1em);
				}

				to {
					transform: translateY(-0.1em);
				}
			}
			.visit-text {
				transform: translateX(5em);
			}
		}
	}
	.remote-offline-btn {
		background-color: #999999;
		cursor: auto;
	}
	.line {
		margin-top: 24px;
		width: 100%;
		height: 1px;
		background-color: rgba(232, 194, 155, 0.2);
	}
	.master-name {
		margin-top: 3px;
		margin-left: 6px;
		color: #999999;
		line-height: 20px;
		font-size: 12px;
		.name-icon {
			display: inline-block;
			margin-top: 1px;
			margin-left: 4px;
			vertical-align: top;
			width: 16px;
			height: 16px;
			background-image: url("../../assets/remote/dot.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}
	}
	.delete-btn {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 44px;
		height: 35px;
		background-image: url("../../assets/vip/delete2.svg");
		background-repeat: no-repeat;
		background-size: 20px 20px;
		background-position: center;
		cursor: pointer;
	}
}
// .service-item::before {
// 	position: absolute;
// 	right: 16px;
// 	bottom: 0;
// 	width: 40px;
// 	height: 25px;
// 	content: "";
// 	background-image: url("../../assets/vip/serviceBg.png");
// 	background-size: 100% 100%;
// }
.service-item:hover {
	border: 1px solid rgba(186, 147, 107, 0.1);
	box-shadow: 0px 3px 7px rgba(202, 208, 219, 0.4);
	background-color: rgba(255, 210, 52, 0.4);
	.remote-btn {
		background-color: #fffbf2;
		box-shadow: 0px 2px 4px rgba(222, 204, 161, 0.5);
		color: #cf9164;
		.remote-hover-btn {
			opacity: 100%;
		}
	}
	.remote-offline-btn {
		color: #7c7671;
	}
}
.service-item.service-offline-item {
	.service-logo {
		background-color: #999999;
		background-size: 60% 60%;
		border: 1px solid #999999;
	}
	.service-logo.service-logo-nas {
		background-image: url(../../assets/common/nas-icon.svg);
	}
	.service-logo.service-logo-router {
		background-image: url(../../assets/common/router-icon.svg);
	}
	.service-logo.service-logo-pc {
		background-image: url(../../assets/common/pc-icon.svg);
	}
}

.service-offline-item:hover {
	border: 1px solid #e8c29b;
	background: linear-gradient(
		152deg,
		rgba(252, 232, 209, 0.3) 21%,
		rgba(243, 209, 169, 0.3) 83%
	);
	.remote-btn {
		background-color: #ffffff;
	}
}
</style>